"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));
var _react = _interopRequireDefault(require("react"));
var _config = require("webmotors-react-pj/config");
var _notification = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/notification"));
const notificationPending = _ref => {
  let {
    type = "number",
    text
  } = _ref;
  const {
    cockpitStorageTerm
  } = window.localStorage;
  if (cockpitStorageTerm) {
    const pendingId = 65;
    const termsJSON = JSON.parse(cockpitStorageTerm);
    const [termsPending] = termsJSON.term_status.filter(item => item.id === pendingId);
    if (termsPending) {
      const {
        length
      } = termsPending.categories.flatMap(item => item.terms);
      const quantityTerms = length > 100 ? "+99" : length;
      return type === "number" ? quantityTerms : text;
    }
    return "";
  }
  return "";
};
const translate = {
  pageStatus: {
    load: "Carregando..."
  },
  webinput: {
    default: "",
    required: "Preencha o campo obrigatório",
    email: "Digite um e-mail válido",
    emailLogin: "Digite um e-mail válido",
    date: "Digite uma data válida",
    dateShort: "Digite uma data simplificada válida",
    password: "Digite todos critérios de senha válidos",
    passwordWeakened: "Digite todos critérios de senha válidos",
    url: "Digite uma url válida (ex.: https://www.webmotors.com.br)",
    time: "Digite um horário válido",
    nameSurname: "Digite um nome e sobrenome válido",
    plate: "Digite uma placa de veículo válida",
    tel: "Digite um telefone válido",
    telMask: "(99) 9999-99999",
    telFn: value => !/^\(?\d{2,3}\)?\s?\w{4,5}-?\w{4,5}$/.test(value),
    mobileMask: "(99) 9999-99999",
    mobileFn: value => !/^\(?\d{2,3}\)?\s?\w{4,5}-?\w{4,5}$/.test(value),
    zipcode: "Digite um CEP válido",
    zipcodeMask: "99999-999",
    zipcodeFn: value => !/^\w{5}-\w{3}$/.test(value),
    document: "Digite um CPF válido",
    documentMask: "999.999.999-99",
    documentFn: value => {
      const cpf = value.replace(/[^\d]+/g, "");
      let add;
      let rev;
      let i;
      if (cpf === "") {
        return true;
      }
      if (/0{11}|1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11}/.test(cpf)) {
        return true;
      }
      add = 0;
      for (i = 0; i < 9; i++) {
        add += (0, _parseInt2.default)(cpf.charAt(i), 10) * (10 - i);
      }
      rev = 11 - add % 11;
      if (rev === 10 || rev === 11) {
        rev = 0;
      }
      if (rev !== (0, _parseInt2.default)(cpf.charAt(9), 10)) {
        return true;
      }
      add = 0;
      for (i = 0; i < 10; i++) {
        add += (0, _parseInt2.default)(cpf.charAt(i), 10) * (11 - i);
      }
      rev = 11 - add % 11;
      if (rev === 10 || rev === 11) {
        rev = 0;
      }
      if (rev !== (0, _parseInt2.default)(cpf.charAt(10), 10)) {
        return true;
      }
      return false;
    },
    documentCompany: "Digite um CNPJ válido",
    documentCompanyMask: "99.999.999/9999-99",
    documentCompanyFn: value => {
      const cnpj = value.replace(/\D/g, "");
      let i;
      let tamanho;
      let numeros;
      let soma;
      let pos;
      let resultado;
      if (cnpj === "" || cnpj.length !== 14 || /0{14}|1{14}|2{14}|3{14}|4{14}|5{14}|6{14}|7{14}|8{14}|9{14}/.test(cnpj)) {
        return true;
      }
      tamanho = cnpj.length - 2;
      numeros = cnpj.substring(0, tamanho);
      const digitos = cnpj.substring(tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
          pos = 9;
        }
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado !== (0, _parseInt2.default)(digitos.charAt(0), 10)) {
        return true;
      }
      numeros = cnpj.substring(0, ++tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
          pos = 9;
        }
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado !== (0, _parseInt2.default)(digitos.charAt(1), 10)) {
        return true;
      }
      return false;
    },
    renavam: "Digite um renavam válido",
    equal: input => "Digite um valor igual ao campo \"".concat(input && input.previousElementSibling.textContent, "\""),
    min: min => "Digite um n\xFAmero maior que ".concat(min),
    max: max => "Digite um n\xFAmero menor que ".concat(max),
    minMax: (min, max) => "Digite um n\xFAmero entre ".concat(min, " e ").concat(max)
  },
  nps: {
    Step1Text: "\n            Com base na sua experi\xEAncia com a Webmotors,\n            como voc\xEA classifica os servi\xE7os prestados, em uma escala de 0 a 10?\n        ",
    Step1Description: "Explique o que te motivou a atribuir esta nota",
    Step1ButtonSend: "Enviar",
    Step1ButtonDecline: "Agora não",
    Step2Text: "Agradecemos a sua resposta",
    Step2Button: "Continuar"
  },
  main: {
    errorTitle: "Aplicação indisponível",
    reloadPage: "Recarregar página",
    pleaseEnterContact: "Por favor entre em contato conosco.",
    loggedFromHub: "Você está logado via HUB."
  },
  utils: {
    status0: "Erro não parametrizado",
    status400: "Dados inválidos",
    status401: "Usuário não autorizado para esta ação",
    status403: "Usuário não autorizado para esta ação. Verifique com o administrador da loja",
    status404: "Não conseguimos encontrar o que você estava procurando, tente novamente em instantes.",
    status405: "O método HTTP não está suportado",
    status407: "Credencias de autenticação por proxy server inválida",
    status408: "Conexão encerrada pelo servidor, por questão de desuso",
    status409: "Conflito com o recurso que está no servidor",
    status411: "Content-Length no server está indefinida",
    status412: "Acesso negado ao recurso de destino",
    status413: "Carga de requisição mais larga que os limites estabelecidos pelo servidor",
    status414: "URI maior do que o servidor aceita interpretar",
    status415: "Servidor se recusa a aceitar este formato de payload",
    status416: "Servidor não pode atender ao Header Range solicitado",
    status417: "Expectativa enviada no cabeçalho da requisição Expect não foi suprida",
    status500: "Ops! O Cockpit está em manutenção e nossa equipe já está atuando para resolver, fique tranquilo que já já voltamos.",
    status501: "Ação indisponível, tente novamente em instantes.",
    status502: "Sistema indisponível, por favor entre em contato conosco.",
    status503: "Sistema indisponível, tente novamente em instantes.",
    status504: "Ação indisponível, tente novamente.",
    status505: "Versão HTTP não é suportada pelo servidor",
    status507: "Servidor não suporta armazenar este dado",
    status508: "Servidor finalizou a operação porque encontrou um loop infinito"
  },
  menu: {
    default: [{
      "menu": "Início",
      "url": "http://local.cockpit.com.br:8000/",
      "icone": "/product-inicio.svg",
      "order": 1,
      "subMenu": [],
      "key": 1
    }, {
      "menu": "CRM",
      "url": "#",
      "icone": "/product-crm.svg",
      "order": 1,
      "key": 2,
      "subMenu": [{
        "menu": "Painel",
        "url": "http://local.cockpit.com.br:8000/crm/dashboard",
        "icone": "",
        "key": 24,
        "subMenu": []
      }, {
        "menu": "Gerenciar leads",
        "url": "http://local.cockpit.com.br:8000/crm/manage-leads",
        "icone": "",
        "key": 25,
        "subMenu": []
      }, {
        "menu": "Minhas atividades",
        "url": "http://local.cockpit.com.br:8000/crm/schedule",
        "icone": "",
        "key": 26,
        "subMenu": []
      }, {
        "menu": "Relatórios de leads",
        "url": "http://local.cockpit.com.br:8000/crm/reports",
        "icone": "",
        "key": 27,
        "subMenu": []
      }, {
        "menu": "Relatórios de ligações",
        "url": "http://local.cockpit.com.br:8000/reports/calls",
        "notification": {
          "type": "text",
          "command": "badge",
          "text": ""
        },
        "order": 1,
        "key": 31,
        "subMenu": []
      }, {
        "menu": "Integrações",
        "url": "http://local.cockpit.com.br:8000/crm/integration",
        "icone": "",
        "key": 29,
        "subMenu": []
      }, {
        "menu": "Configurações",
        "url": "http://local.cockpit.com.br:8000/crm/configuration",
        "icone": "",
        "key": 28,
        "subMenu": []
      }]
    }, {
      "menu": "Estoque",
      "url": "#",
      "icone": "/product-estoque-v2.svg",
      "order": 1,
      "key": 5,
      "subMenu": [{
        "menu": "Gerenciar estoque",
        "url": "http://local.cockpit.com.br:8000/inventory",
        "icone": "",
        "key": 15,
        "subMenu": []
      }, {
        "menu": "Incluir veículo",
        "url": "http://local.cockpit.com.br:8000/inventory/list-vehicle",
        "icone": "",
        "key": 16,
        "subMenu": []
      }, {
        "menu": "Relatório",
        "url": "http://local.cockpit.com.br:8000/inventory/reports/stock",
        "icone": "",
        "key": 40,
        "subMenu": []
      }, {
        "menu": "Classificados integrados",
        "url": "http://local.cockpit.com.br:8000/inventory/channels",
        "icone": "",
        "key": 19,
        "subMenu": []
      }, {
        "menu": "Configurações",
        "url": "http://local.cockpit.com.br:8000/inventory/config",
        "icone": "",
        "key": 33,
        "subMenu": []
      }]
    }, {
      "menu": "Comprar carros",
      "url": "#",
      "notification": {
        "type": "text",
        "command": "badge",
        "text": "Novo"
      },
      "icone": "/product-reposicao.svg",
      "order": 1,
      "key": 45,
      "subMenu": [{
        "menu": "Como funciona",
        "url": "http://local.cockpit.com.br:8000/how-works",
        "icone": "",
        "key": 46,
        "subMenu": []
      }, {
        "menu": "Ver ofertas",
        "url": "http://local.cockpit.com.br:8000/catalog",
        "icone": "",
        "key": 47,
        "subMenu": []
      }]
    }, {
      "menu": "Loja",
      "url": "http://local.cockpit.com.br:8000/store/catalog/begin",
      "notification": {
        "type": "text",
        "command": "badge",
        "text": ""
      },
      "icone": "/product-store.svg",
      "order": 1,
      "key": 44
    }, {
      "menu": "+ Fidelidade",
      "url": "http://local.cockpit.com.br:8000/moreloyalty/",
      "icone": "/product-maisfidelidade.svg",
      "order": 1,
      "key": 6,
      "subMenu": []
    }, {
      "menu": "Universidade",
      "url": "http://local.cockpit.com.br:8000/university/wm-cockpit",
      "icone": "/product-universidade.svg",
      "order": 1,
      "key": 7,
      "subMenu": []
    }, {
      "menu": "Mídias",
      "url": "#",
      "icone": "/product-campanhas.svg",
      "order": 1,
      "key": 3,
      "subMenu": [{
        "menu": "Mídias Webmotors",
        "url": "http://local.cockpit.com.br:8000/campaigns/webmotorsmedia",
        "icone": "",
        "key": 12,
        "subMenu": []
      }, {
        "menu": "Webmotors TV",
        "url": "http://local.cockpit.com.br:8000/campaigns/webmotorstv",
        "icone": "",
        "key": 29,
        "subMenu": []
      }]
    }, {
      "menu": "Site",
      "url": "#",
      "icone": "/product-site.svg",
      "order": 1,
      "key": 4,
      "subMenu": [{
        "menu": "Configurar site",
        "url": "http://local.cockpit.com.br:8000/site",
        "icone": "",
        "key": 42,
        "subMenu": []
      }, {
        "menu": "Gerenciar acessos",
        "url": "http://local.cockpit.com.br:8000/inventory/php/perfil/dados-acesso",
        "icone": "",
        "key": 43,
        "subMenu": []
      }]
    }, {
      "menu": "Conta",
      "url": "#",
      "notification": {
        "type": "text",
        "text": "termos pendentes"
      },
      "icone": "/product-conta.svg",
      "order": 2,
      "key": 10,
      "subMenu": [{
        "menu": "Termo de Adesão",
        "url": "http://local.cockpit.com.br:8000/terms/pending",
        "icone": "",
        "key": 20,
        "subMenu": [],
        "notification": {
          "type": "number"
        }
      }, {
        "menu": "Usuários",
        "url": "http://local.cockpit.com.br:8000/user/listing",
        "icone": "",
        "key": 21,
        "subMenu": []
      }, {
        "menu": "Meu Plano",
        "url": "http://local.cockpit.com.br:8000/my-plan/plan",
        "icone": "",
        "key": 22,
        "subMenu": []
      }, {
        "menu": "Política de privacidade",
        "url": "https://www.webmotors.com.br/seguranca/politica-de-privacidade/",
        "icone": "",
        "key": 30,
        "subMenu": []
      }]
    }, {
      "menu": "Central de ajuda",
      "url": "https://ajuda.cockpit.com.br/",
      "icone": "/product-centralajuda.svg",
      "order": 2,
      "key": 11,
      "subMenu": [],
      "tracking": "pj_cockpit_duvidasFrequentes"
    }]
  },
  login: {
    title: "Você no comando do seu negócio",
    subTitle: "Conheça todas as soluções Webmotors e Santander Financiamentos integradas em um único lugar para você vender muito mais.",
    recoverPass: "Esqueceu sua senha?",
    loginButton: "Acessar o Cockpit",
    secondTitle: "Temos soluções que te ajudam no dia a dia",
    productText1: "Pra vender mais e com mais lucro.",
    productText2: "Pra sair na frente e definir o futuro do mercado.",
    productText3: "Pra ter todos os recursos financeiros que precisa.",
    productText4: "Pra comprar com mais vantagens.",
    playVideo: "Assistir ao vídeo",
    thirdTitle: "E você ainda pode fazer a gestão da sua loja na palma da sua mão",
    thirdSubTitle: "Gerencie seus leads e seu estoque de qualquer lugar e a qualquer hora.",
    joinText1: "Se interessou?",
    joinText2: "Então não perca essa oportunidade",
    joinText3: "Você no comando do seu negócio.",
    joinNow: "Acesse já",
    loginFrom: "Você está logando via ",
    redirectIn: "Você será redirecionado em",
    seconds: " segundos",
    password: "Senha",
    email: "E-mail",
    keepLogged: "Manter conectado",
    urlAppApple: "https://apps.apple.com/br/app/revendedor-webmotors/id1069917512",
    urlAppAndroid: "https://play.google.com/store/apps/details?id=br.com.webmotors.webmotorsrevendedor.production",
    brandFidelity: "/assets/img/brands/fidelidade.svg",
    brandStock: "/assets/img/brands/estoque.svg",
    brandUniversity: "/assets/img/brands/universidade.svg",
    brandHotdeals: "/assets/img/brands/feiroes.svg",
    passwordUpdateSuccess: "Senha atualizada com sucesso",
    userNotAllowed: "Nome de usuário e/ou senha inválido",
    forgotPasswordError: "Ops! Parece que algo deu errado. Sua conta será bloqueada após 5 tentativas de acesso sem sucesso. Revise seus dados ou ",
    forgotPasswordErrorLink: " clique aqui para redefinir sua senha.",
    buttonContact: "",
    metaDefaultDescripion: "Ecossistema de soluções para as lojas de todo o mercado brasileiro. Fornecendo informações para a tomada de decisões mais assertivas e lucrativas."
  },
  header: {
    myProfile: "Meu perfil",
    registrationData: "Dados cadastrais",
    exit: "Sair",
    allStores: "Todas as lojas",
    selectStore: "Selecionar loja",
    errorList: "Erro de listagem",
    searchStore: "Buscar por loja",
    select: "Selecionar",
    login: "Login",
    solutions: "Soluções",
    crm: "CRM",
    stock: "Estoque",
    autoguru: "Autoguru",
    university: "Universidade",
    fairgrounds: "Feirões",
    menuSolutions: [{
      href: "/solutions/crm",
      name: "CRM"
    }, {
      href: "/solutions/inventory",
      name: "Estoque"
    }, {
      href: "/solucoes/autoguru",
      name: "Autoguru"
    }, {
      href: "/solutions/university",
      name: "Universidade"
    }, {
      href: "/solutions/hot-deals",
      name: "Feirões"
    }, {
      href: "/solutions/webmotorstv",
      name: "Webmotors TV"
    }, {
      href: "/solutions/fidelity",
      name: "+ Fidelidade"
    }],
    notification: _react.default.createElement(_notification.default, null),
    intercomId: "skfddf3u",
    logoutLink: "".concat(_config.UrlCockpit, "/logout")
  },
  footer: {
    copyrights: "Webmotors S.A. Todos os direitos reservados.",
    downloadOurApps: "Baixe nosso app:",
    logoWebmotors: "",
    logoSantander: "",
    component: '',
    help: "Ajuda"
  },
  form: {
    buttonWait: "Aguarde..."
  },
  storeGroup: {
    title: "Selecionar loja",
    subtitle: "Selecione a loja que gostaria de visualizar as informações.",
    selectStates: "Selecionar por estado"
  }
};
var _default = exports.default = translate;